export default __webpack_public_path__ + "static/media/canap.db1a5662.jpg";